export default __webpack_public_path__ + "static/media/hero-contact-image.25ab2e9b.jpg";